import React from 'react';
import styled from 'styled-components';
import { HStack, Text } from '@chakra-ui/react';
import { colors } from '../App/ChakraTheme';

const StyledRow = styled(HStack)`
  width: 100%;
  position: relative;

  & > .body-x-small {
    margin-left: 30px;
    color: ${colors.applyOpacity(colors.midnight, 0.8)};
    max-width: 252px;
    min-width: 252px;
    color: ${(props) =>
      props.active
        ? colors.darkblue
        : colors.applyOpacity(colors.midnight, 0.8)} !important;
    font-size: 13px !important;
  }

  & > div.circle {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    margin-top: 3px !important;
    background-color: ${colors.white};
    border: 1px solid ${colors.applyOpacity(colors.mischka, 0.8)};
    border-color: ${(props) =>
      props.active
        ? colors.darkblue
        : colors.applyOpacity(colors.mischka, 0.8)};
  }
`;

interface LessonNameProps {
  className?: string;
  children?: any;
  active?: boolean;
  disabled?: boolean;
  highlight?: boolean;
  isDone?: boolean;
  onClick?: () => void;
}

export const LessonName: React.FC<LessonNameProps> = ({
  className,
  children,
  active,
  onClick,
}) => {
  return (
    <StyledRow
      className={`v-center ${className}`}
      active={active?.toString()}
      onClick={onClick}
      spacing={0}
      justifySelf="start"
    >
      <div className="circle" />
      <Text as="div" textStyle="bodyXSmall" className="body-x-small">
        {children}
      </Text>
    </StyledRow>
  );
};
